module.exports = __webpack_public_path__ + "static/media/icon-paypal-full.58812e27.png";